export const ALERT_INITIAL_FILTER_FIELDS = ['case_type_name', 'case_type_category', 'status']
